import React, { useCallback, useEffect, useState, useMemo } from "react";
import styles from "./NewDashboard.module.scss";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { UserRoleEnum } from "../../types";
import { useIntercom } from "react-use-intercom";
import { useAnalytics, Events } from "../../hooks/useAnalytics";
import { useHistory } from "react-router-dom";
import { useUser } from "@hooks";
import UnitProgressModal from "@src/components/unit-progress-modal/UnitProgressModal";
import TitleCard from "./cards/TitleCard";
import MainCard from "./cards/MainCard";
import Icon from "./icons/Icon";
import { InviteSlidingPanel } from "@src/pages/admin/users/invite-slide/inviteSlidePanel";
import { InviteSlidingPanel as SAInviteSlidePanel } from "@src/pages/super-admin/users/invite-slide/inviteSlidePanel";

import ImageLeft from "./assets/leftshape.svg?react";
import ImageRight from "./assets/rightshape.svg?react";

import ImageAdmin from "./assets/admincard.svg?url";
import ImageReport from "./assets/reportcard.svg?url";
import ImageGettingstarted from "./assets/gettingstartedcard.svg?url";
import ImageTransitions from "./assets/transitionsback.svg?url";
import ImageResources from "./assets/educatorcard.svg?url";
import ImageSupport from "./assets/supportcard.svg?url";
import ImageOnboarding from "./assets/onboardingcard.svg?url";
import ImageAccount from "./assets/accountcard.svg?url";
import ImageOnboardingHandbook from "./assets/onboarding-handbook.png";
import ImageCareGiverIntroduction from "./assets/caregiver-introduction.png";
import ImageEducatorOnboarding from "./assets/educator-onboarding.png";
import ImagePlatformTour from "./assets/platform-tour.png";
import ImageGettingStartedGuide from "./assets/getting-started-guide.png";
import ImageSummaryReports from "./assets/summary-reports.png";
import ImageStudentWellbeing from "./assets/student-wellbeing-report.png";
import ImageStudyGuides from "./assets/study-guides.png"
import ImagePreProgramQuiz from "./assets/student-pre-program-quiz.png";
import ImageLessonLibrary from "./assets/lessonlibrary.png";
import ImageProgram from "./assets/program.png";
import ImageAuProgram from "./assets/program_au.png";
import ImageUnitProgram from "./assets/program_unit.png";
import ImageViewActiveLessons from "./assets/view-active-lessons.png";
import ImageGroupOnboarding from './assets/group-onboarding.png'
import ImageKickOffCall from './assets/kick-off-call.jpg'
import Handbook from "./handbook-modal/Handbook";
import ImageResilient from "./assets/imagecrc.png";
import ImageTransition from "./assets/transitionitem.png";
import ImageScopeSequence from "./assets/scope-sequence.svg?url";
import ImageLessonLibraryCard from "./assets/lessonlibrarycard.svg?url";
import ImageProgramCard from "./assets/programscard.svg?url";
import ImageLessonRoadMaps from "./assets/lesson-roadmaps.png";
import ImageUsageGraph from "./assets/usage-graph.png";
import ImageSchoolLeader from "./assets/school-leader.png";
import ImageDistrictLeader from "./assets/district-leader.png";
import ImageBookStudy from "./assets/book-study.png";
import ImageQuickStart from "./assets/quickstart-for-educators.png";
import ImageWideBackground from "./assets/widetilebackground.png";
import ImageEducatorOnboarding1 from "./assets/educator-onboarding1.png"
// Import large SVG as URL so it isn't inlined/processed into JS (prevents deoptimised styling warning)
import ImageOnboardingBookResilienceCard from "./assets/bookresiliencecard.svg?url";
import ImageBookResilience from "./assets/bookresilience.png";
import ImageOutlineRugby from "./assets/outline-rugby-ball.svg?react"
import ImageCareResources from "./assets/na-caresources.png";
import ImageSupportStudent from "./assets/na-supporting.png";
import ImageOutlineJumping from "./assets/outline-jumping.svg?react";
import ImageAuCareResources from "./assets/au-caresources.png";

import {
  WellBeingUnitId,
  IntercomCheckListID,
  EducatorOnboardingId,
  StudentWellBeingSurveyId,
  IconGettingStarted,
  // IconProgram,
  IconStandalone,
  IconAdminTop,
  IconUserManage,
  IconInviteStaff,
  IconViewUsage,
  IconLessonProgress,
  IconReportTop,
  IconExitTicket,
  IconStudentWellbeing,
  IconEducatorOnboarding,
  IconPreProgramQuiz,
  IconClassRoomTop,
  IconAdultResource,
  IconCaregiver,
  IconEducator,
  IconHandbook,
  IconHelp,
  IconChat,
  IconSupport,
  IconMyAccount,
  IconCaregiverIntroduction,
  PlatformTowerId,
  IconGroupOnboarding,
  IconKickOffCall,
  GroupOnboardingId,
  CreatingResilientClassroomsId,
  IconResilent,
  CreatingResilientAusClassroomsId,
  IconMyCollection,
  IconTransitions,
  ProgramID,
  BookStudyUnitName,
  IconSchoolLeader,
  IconProfessional,
} from "@src/constants";
import LessonProgressModal from "@src/components/lesson-progress-modal/LessonProgressModal";
import GradeSelectModal from "@src/components/grade-select-modal/GradeSelectModal";
// import TransitionCard from "./cards/TransitionCard";
import WellBeingFoundationsSection from "./sections/WellbeingFoundations";
import ProgramCard from "./cards/ProgramCard";
import TransitionCard from "./cards/TransitionCard";
// Australia Wellbeing Foundation
import { resetGoogleTranslateWidget } from "@src/utils/helpers";

function Dashboard() {
  const { boot, show, isOpen } = useIntercom();
  const history = useHistory();
  const { trackEvent } = useAnalytics();
  const [user] = useUser();

  const [unitId, setUnitId] = useState("");
  const [assessments, setAssessments] = useState(false);
  const [showUnitModal, setShowUnitModal] = useState(false);
  const [inviteSlide, setInviteSlide] = useState(false);
  const [showHandbook, setShowHandbook] = useState(false);
  const [lessonId, setLessonId] = useState("");
  const [showPlatformTower, setShowPlatformTower] = useState(false);
  const [showAusPreProgram, setShowAusPreProgram] = useState(false);
  const [showSelectGradeModal, setShowSelectGradeModal] = useState(false);
  const [selectedGrade, setSelectedGrade] = useState("");
  const [isPostProgram, setIsPostProgram] = useState(false);

  const isSuperAdmin = useMemo(
    () => user?.role && user.role === UserRoleEnum.SuperAdmin,
    [user?.role]
  );
  const isAdminOrDistAdmin = useMemo(
    () =>
      user?.role &&
      (user.role === UserRoleEnum.DistrictAdmin ||
        user.role === UserRoleEnum.Admin),
    [user?.role]
  );
  const isAdminOrDistAdminOrUser = useMemo(
    () =>
      user?.role &&
      (user.role === UserRoleEnum.DistrictAdmin ||
        user.role === UserRoleEnum.Admin ||
        user.role === UserRoleEnum.User),
    [user?.role]
  );

  const isAussie = useMemo(() => user?.id?.startsWith("AU_"), [user?.id]);
  const isCanada = useMemo(() => user?.id?.startsWith("CA_"), [user?.id]);
  const isUS = useMemo(() => user?.id?.startsWith("US_"), [user?.id]);
  const isTrial = useMemo(() => user?.customer?.trial ?? false, [user?.customer]);
  const isPrimary = useMemo(() => user?.schools?.[0]?.isPrimary ?? false, [user?.schools]);
  const isSouthAU = useMemo(() => user?.customer?.state === 'South Australia' ? true : false, [user?.customer]);

  useEffect(() => {
    boot({
      customAttributes: {
        horizontal_padding: 25,
      },
    });
  }, [boot]);

  useEffect(() => {
    if ((window as any).Intercom && isOpen) {
      (window as any).Intercom("startChecklist", IntercomCheckListID);
    }
  }, [isOpen]);

  useEffect(() => {
    resetGoogleTranslateWidget();
  }, [])

  useEffect(() => {
    if (user?.id && !isSuperAdmin) {
      trackEvent(Events.views.mainDashboard, {
        schoolId: user?.schools?.[0]?.id,
        schoolName: user?.schools?.[0]?.name,
        userId: user?.id,
        userName: `${user?.firstName} ${user?.lastName}`,
      });
    }
  }, [trackEvent, isSuperAdmin, user]);

  const openUserManage = useCallback(() => {
    if (isSuperAdmin) {
      history.push("/super/users");
    } else if (isAdminOrDistAdmin) {
      history.push("/admin/users");
    }
    trackEvent(Events.views.users, {
      schoolId: user?.schools?.[0]?.id,
      schoolName: user?.schools?.[0]?.name,
      userId: user?.id,
      userName: `${user?.firstName} ${user?.lastName}`,
    });
  }, [history, isAdminOrDistAdmin, isSuperAdmin, trackEvent, user]);

  const inviteUserHandler = useCallback(() => {
    setInviteSlide(true);
  }, []);

  const openUsagePage = useCallback(() => {
    if (isSuperAdmin) {
      history.push("/super/usage");  
    } else {
      history.push("/admin/usage");
    }
  }, [history, isSuperAdmin])

  const openExitTicketSummary = useCallback(() => {
    if (isSuperAdmin) {
      history.push("/super/survey-exports");
    } else if (isAdminOrDistAdminOrUser) {
      history.push("/summaryreports");
    }
    trackEvent(Events.views.exitTicketReports, {
      schoolId: user?.schools?.[0]?.id,
      schoolName: user?.schools?.[0]?.name,
      userId: user?.id,
      userName: `${user?.firstName} ${user?.lastName}`,
    });
  }, [history, isAdminOrDistAdminOrUser, isSuperAdmin, trackEvent, user]);

  const openLessonLibrary = useCallback(() => {
    history.replace("/lessons?tab=library");
  }, [history]);

  const openTransitions = useCallback(() => {
    history.push(`/program/transitions?pid=${ProgramID.AUSTRANSITIONS}`);
  }, [history]);

  const openMCPrograms = useCallback(() => {
    history.replace("/lessons?tab=programs");
  }, [history]);

  const openAusStudentVoiceProgram = useCallback(() => {
    history.push("/units/studentvoiceseries");
  }, [history]);

  const openWellBeingUnit = useCallback(() => {
    setUnitId(WellBeingUnitId);
    setAssessments(false);
    setShowUnitModal(true);
    trackEvent(Events.actions.educatorWellbeingUnitOpen, {
      schoolId: user?.schools?.[0]?.id,
      schoolName: user?.schools?.[0]?.name,
      userId: user?.id,
      userName: `${user?.firstName} ${user?.lastName}`,
    });
  }, [trackEvent, user]);

  const openQuickStartEducator = useCallback(() => {
    if (isAussie) {
      window.open(
      "https://help.openparachuteschools.com/en/collections/10400596-quickstart-for-educators",
      "_blank"
      );
      return;
    } else {
      window.open(
        "https://help.openparachuteschools.com/en/collections/10400596-quickstart-for-educators",
        "_blank"
      );
      return;
    }
  }, [isAussie]);

  const openGroupOnboardingUnit = useCallback(() => {
    setUnitId(GroupOnboardingId);
    setAssessments(false);
    setShowUnitModal(true);
  }, []);

  const openCreatingResilientClassroomsUnit = useCallback(() => {
    setUnitId(isAussie ? CreatingResilientAusClassroomsId : CreatingResilientClassroomsId);
    setAssessments(false);
    setShowUnitModal(true);
  }, [isAussie]);

  const openPlatformTour = useCallback(() => {
    setLessonId(EducatorOnboardingId);
    setShowPlatformTower(true);
  }, []);

  const openStudentWellBeingUnit = useCallback(() => {
    setUnitId(StudentWellBeingSurveyId);
    setAssessments(false);
    setShowUnitModal(true);
  }, []);

  const openLessonProgress = useCallback(() => {
    history.push("/lessonprogress");
  }, [history]);

  const openProfessionalDevelopment = useCallback(() => {
    if (isAussie) {
      history.push(`/program/professionaldevelopment?pid=${ProgramID.AUPROFESSIONALDEV}`);
    } else {
      history.push(`/program/professionaldevelopment?pid=${ProgramID.PROFESSIONALDEV}`);
    }
  }, [history, isAussie]);

  const openPrePromQuizUnit = useCallback(() => {
    setUnitId("");
    if (isAussie) {
      setLessonId('');
      setShowSelectGradeModal(true)
      return
    } else {
      setAssessments(true);
      setShowUnitModal(true);
    }

    trackEvent(Events.actions.preProgramQuizOpen, {
      unit_name: "Pre-Program Quiz",
      schoolId: user?.schools?.[0]?.id,
      schoolName: user?.schools?.[0]?.name,
      userId: user?.id,
      userName: `${user?.firstName} ${user?.lastName}`,
    });
  }, [isAussie, user, trackEvent]);

  const openPostPromQuizUnit = useCallback(() => {
    setUnitId("");
    if (isAussie) {
      return
    } else {
      // setAssessments(true);
      setIsPostProgram(true);
      setShowUnitModal(true);
    }

    trackEvent(Events.actions.preProgramQuizOpen, {
      unit_name: "Post-Program Quiz",
      schoolId: user?.schools?.[0]?.id,
      schoolName: user?.schools?.[0]?.name,
      userId: user?.id,
      userName: `${user?.firstName} ${user?.lastName}`,
    });
  }, [isAussie, user, trackEvent]);

  const handleOpenAusPreProgramQuiz = useCallback((programId: string) => {
    if (programId) {
      setSelectedGrade(programId)
      setShowAusPreProgram(true);
      setShowSelectGradeModal(false);
    }
    trackEvent(Events.actions.preProgramQuizOpen, {
      unit_name: "Pre-Program Quiz",
      schoolId: user?.schools?.[0]?.id,
      schoolName: user?.schools?.[0]?.name,
      userId: user?.id,
      userName: `${user?.firstName} ${user?.lastName}`,
    });
  }, [user, trackEvent])

  const openCaregiver = useCallback(() => {
    history.push("/caregiver");
  }, [history]);

  const openAssessmentsStudyguides = useCallback(() => {
    if (isCanada || isUS) return;
    history.push("/assessments?tab=1");
  }, [history, isUS, isCanada]);

  const openMyProfile = useCallback(() => {
    history.push("/profile");
  }, [history]);

  const handleCloseUnit = () => {
    setShowUnitModal(false);
    setAssessments(false);
  };
  
  const openCurriculumMapping = () => {
    if (isAussie) {
      window.open(
        "https://help.openparachuteschools.com/en/articles/6949377-curriculum-mapping",
        "_blank"
      );
      return false;
    }
  };

  const openBookResilience = () => {
    if (isAussie && isSouthAU) {
      window.open(
        "https://calendly.com/adelaidecrows-foundation/open-parachute-wellbeing-visit?month=2025-08",
        "_blank"
      );
      return false;
    }
  };

  const openSupportingStudentBook = () => {
    window.open(
      "https://www2.gov.bc.ca/assets/gov/erase/documents/mental-health-wellness/supporting-students-in-times-of-change.pdf",
      "_blank"
    );
  }

  const openHandbook = () => {
    if (isAussie) {
      window.open(
        "https://cdn.openparachuteschools.com/pdf/Open+Parachute+-+Onboarding+Handbook+AU.pdf",
        "_blank"
      );
      return false;
    } else {
      window.open(
        "https://cdn.openparachuteschools.com/pdf/Onboarding+Handbook+OP.pdf",
        "_blank"
      );
      return false;
    }
  };

  const openScheduleKickOffCall = () => {
    if (isTrial) {
      return
    }
    if (isAussie) {
      window.open(
        "https://calendly.com/openparachute-rikki/kickoff-call",
        "_blank"
      );
      return false;
    } else {
      window.open(
        "https://calendly.com/madison-hilliard/30min?month=2025-07",
        "_blank"
      );
      return false;
    }
  }

  const openEducatorOnboardingProgram = useCallback(() => {
    history.push(`/program/educatoronboarding?pid=${ProgramID.EDUCATORONBOARDING}`);
  }, [history]);

  const openSchoolLeaderOnboarding = () => {
    if (isTrial || isAussie) {
      return
    }

    window.open(
      "https://learn.openparachuteschools.com/standalone/school-leader-onboarding",
      "_blank"
    );
  }

  const openDistrictLeaderOnboarding = () => {
    if (isTrial || isAussie) {
      return
    }

    window.open(
      "https://learn.openparachuteschools.com/standalone/district-leader-onboarding",
      "_blank"
    );
  }

  const openBookStudy = useCallback(() => {
    history.push(`/${BookStudyUnitName}`);
  }, [history]);

  const openScopeSequece = () => {
    if (isAussie) return
    window.open(
      "https://help.openparachuteschools.com/en/collections/9385363-scope-sequence",
      "_blank"
    );
  }

  const openCaregiverIntroduction = () => {
    if (isUS) {
      window.open(
        "https://cdn.openparachuteschools.com/pdf/Open+Parachute+Wellbeing+Resources+for+Caregivers+US.pdf",
        "_blank"
      );
      return false;
    }
    if (isCanada) {
      window.open(
        "https://cdn.openparachuteschools.com/pdf/Open+Parachute+Wellbeing+Resources+for+Caregivers+CA.pdf",
        "_blank"
      );
      return false;
    }
    if (isAussie) {
      window.open(
        "https://cdn.openparachuteschools.com/pdf/Open+Parachute+Wellbeing+Resources+AU.pdf",
        "_blank"
      );
      return false;
    }
  };

  const openHelpCentre = () => {
    window.open("https://help.openparachuteschools.com/", "_blank");
    return false;
  };

  const openLiveChat = () => {
    show();
  };

  const intercomGettingStarted = () => {
    if (isAussie) {
      window.open(
        "https://cdn.openparachuteschools.com/pdf/getting-started-guide-au.pdf",
        "_blank"
      );
      return;
    } else {
      window.open(
        "https://help.openparachuteschools.com/en/collections/10703611-roadmaps",
        "_blank"
      );
      return;
    }
  };

  const classroomLessons = () => {
    return (
      <>
        <TitleCard
          title="Classroom Lessons"
          detail={isAussie ? "Lessons for Getting Started;  Sequenced Instruction" : "View all Classroom Lessons and Sequenced Programs"}
          leftIcon={<Icon src={IconClassRoomTop} isTitle={true} />}
        />
        {isAussie ? <>
          {isPrimary ?
          <div className={styles.naClassroomCardView}>
            <ProgramCard
              titleLine1={"Student Voice"}
              titleLine2={"Series"}
              backGroundUrl={ImageProgramCard}
              imageUrl={ImageUnitProgram}
              section="Classroom"
              isSummary={true}
              openCard={openAusStudentVoiceProgram}
              mainIcon={<Icon src={IconMyCollection} size={56}/>}
              hoverTitle="These pre-sequenced Lessons allow students to dive deep into peer stories by following their journey across multiple classes."
              hoverHint="These Units contain multiple lessons that must be run in sequence."
            />
            <ProgramCard
              titleLine1={"Transitions™"}
              titleLine2=""
              backGroundUrl={ImageTransitions}
              imageUrl={ImageTransition}
              section="Classroom"
              openCard={openTransitions}
              mainIcon={<Icon src={IconTransitions} size={52}/>}
              isFeatured={true}
              isTransition={isAussie}
              hoverTitle="Transitions™ is designed to support students’ wellbeing during the Middle-Year transitions between grades 5 and 9."
              hoverHint=""
            />
          </div> : <div className={styles.naClassroomCardView}>
            <ProgramCard
              titleLine1={"Programs"}
              titleLine2=""
              backGroundUrl={ImageProgramCard}
              imageUrl={ImageAuProgram}
              section="Classroom"
              openCard={openMCPrograms}
              mainIcon={<Icon src={IconMyCollection} size={52}/>}
              hoverTitle="Programs contain sequenced lessons that are designed to be completed in series and allow for more depth and understanding into a particular topic area."
              hoverHint=""
            />
            <ProgramCard
              titleLine1={"Standalone Lessons"}
              titleLine2={""}
              backGroundUrl={ImageLessonLibraryCard}
              imageUrl={ImageLessonLibrary}
              section="Classroom"
              isSummary={true}
              openCard={openLessonLibrary}
              mainIcon={<Icon src={IconStandalone} size={56}/>}
              isFeatured={true}
              hoverTitle="This is the hub for all lessons available on Open Parachute. Lessons are organized by grade and further categorized by theme. Search for lessons based on grade, topic, lesson type, tier and competency."
              hoverHint=""
            />
          </div>}
        </> :
        <>
          <div className={styles.naClassroomCardView}>
            <ProgramCard
              titleLine1={"Lesson Library"}
              titleLine2={""}
              backGroundUrl={ImageLessonLibraryCard}
              imageUrl={ImageLessonLibrary}
              section="Classroom"
              isSummary={true}
              openCard={openLessonLibrary}
              mainIcon={<Icon src={IconStandalone} size={56}/>}
              hoverTitle="This is the hub for all lessons available on Open Parachute. Lessons are organized by grade and further categorized by theme. Search for lessons based on grade, topic, lesson type, tier and competency."
              hoverHint=""
            />
            <ProgramCard
              titleLine1={"Programs"}
              titleLine2=""
              backGroundUrl={ImageProgramCard}
              imageUrl={ImageProgram}
              section="Classroom"
              openCard={openMCPrograms}
              mainIcon={<Icon src={IconMyCollection} size={52}/>}
              isFeatured={true}
              isTransition={isAussie}
              hoverTitle="Programs contain sequenced lessons that are designed to be completed in series and allow for more depth and understanding into a particular topic area."
              hoverHint=""
            />
          </div>
        </>}
      </>
    );
  };

  const reports = () => {
    return (
      <>
        <TitleCard
          title="Assessments & Reports"
          detail="View Summary Reports; Create Assessments"
          leftIcon={<Icon src={IconReportTop} isTitle={true} />}
        />
        <div className={styles.cardView}>
          {<MainCard
            titleLine1={"Student <br/> Pre-Program"}
            titleLine2="Quiz"
            backGroundUrl={ImageReport}
            imageUrl={ImagePreProgramQuiz}
            section="Classroom"
            openCard={openPrePromQuizUnit}
            mainIcon={<Icon src={IconPreProgramQuiz} />}
            isQuizTiles={true}
            hoverTitle="This online quiz will provide you with an indication of your students’ competencies, which can help guide your lesson selections."
            hoverHint="Students require a device to complete the Quiz. It will take approximately 15 minutes."
          />}
          { isAussie ? <MainCard
            titleLine1="Assessments"
            titleLine2="& Study Guides"
            backGroundUrl={ImageReport}
            imageUrl={ImageStudyGuides}
            isImagePadding
            openCard={openAssessmentsStudyguides}
            isComingSoon={!isAussie}
            section="Report"
            mainIcon={<Icon src={IconReportTop} isComingSoon={!isAussie} />}
            isQuizTiles={true}
            hoverTitle="Create your own Assessments based on the specific units your students have completed during the year."
            hoverHint="It’s important to complete the Unit Study Guides, as the Assessments test knowledge specifically relating to the Units!"
          /> : null}
          { isAussie ? <MainCard
            titleLine1="Summary"
            titleLine2="Reports"
            backGroundUrl={ImageReport}
            imageUrl={ImageSummaryReports}
            openCard={openExitTicketSummary}
            isAdmin={true}
            section="Report"
            marginBottom={true}
            mainIcon={<Icon src={IconExitTicket} />}
            isQuizTiles={true}
            hoverTitle="Export Summary Reports for the Pre-Program Quiz, Exit Tickets, and Assessments."
            hoverHint="You can filter by date to select a specific period of time!"
            isSummary={true}
          /> : null}
          {!isAussie && 
            <MainCard
            titleLine1={"Student <br/> Post-Program"}
            titleLine2="Quiz"
            backGroundUrl={ImageReport}
            imageUrl={ImagePreProgramQuiz}
            section="Classroom"
            openCard={openPostPromQuizUnit}
            mainIcon={<Icon src={IconPreProgramQuiz} />}
            isQuizTiles={true}
            hoverTitle="This online quiz will provide you with an indication of your students’ growth across different competencies throughout the school year."
            hoverHint="Students require a device to complete the Quiz. It will take approximately 15 minutes."
          />}
          {(isSuperAdmin || isAdminOrDistAdmin) && isAussie && (
            <MainCard
              titleLine1="Student <br/> Wellbeing"
              titleLine2="Insight Report"
              backGroundUrl={ImageReport}
              imageUrl={ImageStudentWellbeing}
              openCard={openStudentWellBeingUnit}
              isAdmin={true}
              adminIcon={true}
              section="Report"
              mainIcon={<Icon src={IconStudentWellbeing} />}
              isQuizTiles={true}
              hoverTitle="The Student Wellbeing Insight Report provides anonymous self-report information about your students in Grades 4+"
              hoverHint="Only Account Administrators can access and generate this survey."
            />
          )}
          {!isAussie && 
          <MainCard
            titleLine1="Summary"
            titleLine2="Reports"
            backGroundUrl={ImageReport}
            imageUrl={ImageSummaryReports}
            openCard={openExitTicketSummary}
            isAdmin={true}
            section="Report"
            marginBottom={true}
            mainIcon={<Icon src={IconExitTicket} />}
            isQuizTiles={true}
            hoverTitle="Export Summary Reports for the Pre-Program Quiz, Post-Program Quiz and Exit Tickets."
            hoverHint="You can filter by date to select a specific period of time!"
            isSummary={true}
          />}
        </div>
      </>
    );
  };

  if (!user) return null;
  return (
    <>
      <Header isAussie={isAussie} />
      <div className={styles.page}>
        {
          <div className={styles.dashboardBackground}>
            <div className={styles.welcomeBox}>
              <div className={styles.leftImage}>
                <ImageLeft />
              </div>
              <div className={styles.rightImage}>
                <ImageRight />
              </div>
              <div className={styles.shadowView}></div>
              <div className={styles.welcomeContainer}>
                <h2 className={styles.welcomeTitle}>{`Welcome to your Dashboard, `}</h2>
                <span className={styles.nameHighlight}>{user.firstName}</span>
              </div>
            </div>
            {isAussie ? 
            // Australia Main Dashboard
            <div className={styles.mainView}>
              {(isAdminOrDistAdmin || isSuperAdmin) && (
                <>
                  <TitleCard
                    title="User Management"
                    detail="Invite your staff; Manage their accounts; Reset Passwords; View their Usage."
                    leftIcon={<Icon src={IconAdminTop} isTitle={true} />}
                    isAdmin={true}
                  />
                  <div className={styles.cardView}>
                    <MainCard
                      titleLine1="User"
                      titleLine2="Management"
                      backGroundUrl={ImageAdmin}
                      openCard={openUserManage}
                      isAdmin={true}
                      section="Admin"
                      mainIcon={<Icon src={IconUserManage} />}
                      hoverTitle="Manage all your staff. Reset Passwords, check their usage, delete accounts."
                      hoverHint="See the last time a staff member logged in, who hasn’t accepted their invite, and what Lessons they have run!"
                    />
                    <MainCard
                      titleLine1="Invite"
                      titleLine2="Staff"
                      backGroundUrl={ImageAdmin}
                      openCard={inviteUserHandler}
                      isAdmin={true}
                      section="Admin"
                      mainIcon={<Icon src={IconInviteStaff} />}
                      hoverTitle="Click here to open the Invite Panel, where you can invite staff individually or in bulk."
                      hoverHint="There’s 3 ways to get staff access; Individual Invites; Bulk Invites; and a Registration Link"
                    />
                    <MainCard
                      titleLine1="Usage"
                      titleLine2="Insights"
                      imageUrl={ImageUsageGraph}
                      backGroundUrl={ImageAdmin}
                      openCard={openUsagePage}
                      isComingSoon={user.role === UserRoleEnum.User}
                      isAdmin={true}
                      isUsageGraph={true}
                      section="Admin"
                      mainIcon={
                        <Icon src={IconViewUsage} isComingSoon={user.role === UserRoleEnum.User} />
                      }
                      hoverTitle="View all your staff's usage in one place. Track which staff are most active, which grade levels have the highest use, and how many lessons have been completed!"
                    />
                  </div>
                  <TitleCard
                    title="Onboarding Guides"
                    detail="Guides to help you implement Open Parachute in your School"
                    leftIcon={<Icon src={IconHandbook} isTitle={true} />}
                    isAdmin={true}
                  />
                  <div className={styles.cardView}>
                    <MainCard
                      titleLine1="Onboarding"
                      titleLine2="Handbook"
                      imageUrl={ImageOnboardingHandbook}
                      backGroundUrl={ImageOnboarding}
                      openCard={openHandbook}
                      isPdf={true}
                      isAdmin={true}
                      section="onboarding"
                      mainIcon={<Icon src={IconHandbook} />}
                      hoverTitle="The Onboarding Handbook is designed to provide Leadership with a step-by-step guide for introducing Open Parachute to your School."
                      hoverHint="This guide is not intended for individual educators to access."
                    />
                    {isAussie ? <MainCard
                      titleLine1="Group"
                      titleLine2="Onboarding"
                      imageUrl={ImageGroupOnboarding}
                      isImagePadding
                      backGroundUrl={ImageOnboarding}
                      openCard={openGroupOnboardingUnit}
                      isPptIcon={true}
                      section="onboarding"
                      mainIcon={<Icon src={IconGroupOnboarding} />}
                      hoverTitle="This Group Onboarding Presentation is identical to the Educator Onboarding module, but designed to be delivered in a Group setting."
                      hoverHint="Use this Presentation when onboarding your staff as a group."
                    /> : <MainCard
                      titleLine1="Caregiver"
                      titleLine2="Introduction"
                      backGroundUrl={ImageOnboarding}
                      imageUrl={ImageCareGiverIntroduction}
                      openCard={openCaregiverIntroduction}
                      isPdf={true}
                      isAdmin={true}
                      section="onboarding"
                      mainIcon={<Icon src={IconCaregiverIntroduction} />}
                      hoverTitle="Use this guide to introduce Open Parachute to your Caregiver community."
                      hoverHint="Caregivers can access online resources via their own Portal. The link is found in this PDF!"
                    />}
                    {isAussie ? <MainCard
                      titleLine1="Curriculum"
                      titleLine2="Mapping"
                      backGroundUrl={ImageOnboarding}
                      imageUrl={ImageScopeSequence}
                      openCard={openCurriculumMapping}
                      isPdf={true}
                      isAdmin={true}
                      section="onboarding"
                      mainIcon={<Icon src={IconPreProgramQuiz} />}
                      hoverTitle="Open Parachute is aligned to both state and national curriculums. Click here to view our curriculum mapping guides."
                      hoverHint=""
                    /> : <MainCard
                      titleLine1="Group"
                      titleLine2="Onboarding"
                      imageUrl={ImageGroupOnboarding}
                      isImagePadding
                      backGroundUrl={ImageOnboarding}
                      openCard={openGroupOnboardingUnit}
                      isPptIcon={true}
                      section="onboarding"
                      mainIcon={<Icon src={IconGroupOnboarding} />}
                      hoverTitle="This Group Onboarding Presentation is identical to the Educator Onboarding module, but designed to be delivered in a Group setting."
                      hoverHint="Use this Presentation when onboarding your staff as a group."
                    />}
                    <MainCard
                      titleLine1="Schedule"
                      titleLine2="Kick-off Call"
                      backGroundUrl={ImageOnboarding}
                      imageUrl={ImageKickOffCall}
                      isImagePadding
                      openCard={openScheduleKickOffCall}
                      isCalendarIcon={true}
                      isTrial={isTrial}
                      section="onboarding"
                      mainIcon={<Icon src={IconKickOffCall} />}
                      hoverTitle="Book in a Video Conference call with our Team to assist with Implementing Open Parachute at your school."
                      hoverHint="Ensure the key people who oversee Wellbeing at your school can attend this call."
                    />
                    {isAussie ? <MainCard
                      titleLine1="Caregiver"
                      titleLine2="Introduction"
                      backGroundUrl={ImageOnboarding}
                      imageUrl={ImageCareGiverIntroduction}
                      openCard={openCaregiverIntroduction}
                      isPdf={true}
                      isAdmin={true}
                      section="onboarding"
                      mainIcon={<Icon src={IconCaregiverIntroduction} />}
                      hoverTitle="Use this guide to introduce Open Parachute to your Caregiver community."
                      hoverHint="Caregivers can access online resources via their own Portal. The link is found in this PDF!"
                    /> : <MainCard
                      titleLine1="Scope &"
                      titleLine2="Sequence"
                      backGroundUrl={ImageOnboarding}
                      imageUrl={ImageScopeSequence}
                      isImagePadding
                      openCard={openScopeSequece}
                      isPdf={true}
                      section="onboarding"
                      mainIcon={<Icon src={IconPreProgramQuiz} />}
                      hoverTitle="View the Scope & Sequence for each Grade."
                      hoverHint=""
                    />}
                    {isAussie && isSouthAU && <MainCard
                      titleLine1="Book Crows Resilience"
                      titleLine2="Presentation"
                      backGroundUrl={ImageOnboardingBookResilienceCard}
                      imageUrl={ImageBookResilience}
                      openCard={openBookResilience}
                      isImageLargePadding={true}
                      isAdmin={true}
                      section="onboarding"
                      mainIcon={<ImageOutlineRugby />}
                      hoverTitle={<p>Book an <strong>Open Parachute x Crows Players Resilience Talk</strong> for AFL and AFLW players to share their experiences and provide valuable insights on building resilience with your students.</p>}
                      hoverHint=""
                    />}
                  </div>
                </>
              )}
              <TitleCard
                title="Getting Started"
                detail="Prepare to run Lessons; Understand the Platform"
                leftIcon={<Icon src={IconGettingStarted} isTitle={true} />}
              />
              <div className={styles.cardView}>
              {<>
                <MainCard
                  titleLine1="Platform"
                  titleLine2="Tour"
                  backGroundUrl={ImageGettingstarted}
                  imageUrl={ImagePlatformTour}
                  openCard={openPlatformTour}
                  section="Getting"
                  isComingSoon={false}
                  mainIcon={<Icon src={IconSupport} isComingSoon={false} />}
                  hoverTitle="Access a video walkthrough of the entire Open Parachute platform. "
                  hoverHint="Key sections have been separated into their own videos. Select the relevant section, or watch them all!"
                />
                <MainCard
                  titleLine1="Quickstart"
                  titleLine2="for Educators"
                  backGroundUrl={ImageGettingstarted}
                  imageUrl={ImageQuickStart}
                  section="Getting"
                  openCard={openQuickStartEducator}
                  isComingSoon={false}
                  mainIcon={
                    <Icon src={IconEducatorOnboarding} isComingSoon={false} />
                  }
                  hoverTitle="Visit our Help Centre to review helpful documentation to get started. These informative guides are designed to get you up and running quickly!"
                  hoverHint="If you would like to dive deeper, there are plenty of in-depth resources available too!"
                />
                {isAussie ? <MainCard
                  titleLine1="Getting Started"
                  titleLine2="Guide"
                  backGroundUrl={ImageGettingstarted}
                  imageUrl={ImageGettingStartedGuide}
                  isPdf={true}
                  section="Getting"
                  openCard={intercomGettingStarted}
                  mainIcon={<Icon src={IconGettingStarted} />}
                  hoverTitle="Use this Guide to get up and running with Open Parachute quickly!"
                  hoverHint="If you have already been through the Educator Onboarding, you don’t need to read this!"
                /> : <MainCard
                  titleLine1="Lesson"
                  titleLine2="Roadmaps"
                  backGroundUrl={ImageGettingstarted}
                  imageUrl={ImageLessonRoadMaps}
                  section="Getting"
                  openCard={intercomGettingStarted}
                  mainIcon={<Icon src={IconGettingStarted} />}
                  hoverTitle="Lesson Roadmaps provide lesson recommendations for every grade to help you get started quickly."
                  hoverHint="Select the best path based on the needs and comfort level of your class!"
                />}
                </>}
              </div>
              {<WellBeingFoundationsSection isAUuser={isAussie} />}
              {isSuperAdmin || isAdminOrDistAdmin ? (
                <>
                  {classroomLessons()}
                  {reports()}
                </>
              ) : (
                <>
                  {classroomLessons()}
                  {reports()}
                </>
              )}

              <TitleCard
                title="Educator & Caregiver Resources"
                detail="Resources to support Educators and Caregivers"
                leftIcon={<Icon src={IconAdultResource} isTitle={true} />}
              />
              <div className={styles.cardView}>
                <MainCard
                  titleLine1="Professional"
                  titleLine2="Development"
                  backGroundUrl={ImageResources}
                  imageUrl={ImageResilient}
                  section="Resources"
                  openCard={openProfessionalDevelopment}
                  isImagePadding={true}
                  mainIcon={<Icon src={IconProfessional} />}
                  hoverTitle="Professional Development resources for Educators."
                />
                <MainCard
                  titleLine1="Caregiver"
                  titleLine2="Resources"
                  backGroundUrl={ImageResources}
                  imageUrl={ImageAuCareResources}
                  section="Resources"
                  isImagePadding={true}
                  openCard={openCaregiver}
                  mainIcon={<Icon src={IconCaregiver} />}
                  hoverTitle="Resources for Caregivers to help support the wellbeing of their children at home."
                  hoverHint="Caregivers can access these resources using their own Portal. Use the Share button to generate a link!"
                />
              </div>
              <TitleCard
                title="Support"
                detail={`Discover additional information in our ${isUS ? 'Help Center' : 'Help Centre'}, or contact us using the Live Chat`}
                leftIcon={<Icon src={IconSupport} isTitle={true} />}
              />
              <div className={styles.cardView}>
                <MainCard
                  titleLine1="Help"
                  titleLine2={isUS ? 'Center' : 'Centre'}
                  backGroundUrl={ImageSupport}
                  section="Support"
                  openCard={openHelpCentre}
                  mainIcon={<Icon src={IconHelp} />}
                  hoverTitle="Access further help and resources for getting Started."
                  hoverHint={`The ${isUS ? 'Help Center' : 'Help Centre'} also features guides and videos for how to support struggling students.`}
                />
                <MainCard
                  titleLine1="Live"
                  titleLine2="Chat"
                  backGroundUrl={ImageSupport}
                  section="Support"
                  openCard={openLiveChat}
                  mainIcon={<Icon src={IconChat} />}
                  hoverTitle="Chat with a member of the Open Parachute team!"
                  hoverHint="Ask questions about the content, getting started, or any technical issues."
                />
              </div>
              <TitleCard
                title="My Account"
                detail="View active lessons and profile"
                leftIcon={<Icon src={IconMyAccount} isTitle={true} />}
              />
              <div className={styles.cardView}>
                <MainCard
                  titleLine1="View Active"
                  titleLine2="Lessons"
                  backGroundUrl={ImageAccount}
                  imageUrl={ImageViewActiveLessons}
                  section="Support"
                  openCard={openLessonProgress}
                  mainIcon={<Icon src={IconLessonProgress} />}
                  hoverTitle="View all the lessons you have begun and completed."
                  hoverHint="Reset your Lesson Progress Bars at the beginning of each new School Year!"
                />
                <MainCard
                  titleLine1="My"
                  titleLine2="Profile"
                  backGroundUrl={ImageAccount}
                  section="Profile"
                  openCard={openMyProfile}
                  mainIcon={<Icon src={IconMyAccount} />}
                />
              </div>
            </div> :
            // North American Main Dashboard 
            <div className={styles.mainView}>
                <>
                  <TitleCard
                    title="Onboarding Resources"
                    detail={(isAdminOrDistAdmin || isSuperAdmin) ? "Guides to help you implement Open Parachute in your School" : "Resources to help you implement Open Parachute"}
                    leftIcon={<Icon src={IconHandbook} isTitle={true} />}
                  />
                  {(isAdminOrDistAdmin || isSuperAdmin) ? (
                  <div className={styles.cardView}>
                    <MainCard
                      titleLine1="Educator"
                      titleLine2="Onboarding"
                      backGroundUrl={ImageOnboarding}
                      imageUrl={ImageEducatorOnboarding}
                      section="Getting"
                      openCard={openEducatorOnboardingProgram}
                      isComingSoon={false}
                      mainIcon={
                        <Icon src={IconEducatorOnboarding} isComingSoon={false} />
                      }
                      hoverTitle="Prepare teachers to confidently deliver the program in their classrooms. Learn how to navigate the platform and effectively implement the lesson materials with students."
                      hoverHint=""
                    />
                    <MainCard
                      titleLine1="School Leader"
                      titleLine2="Onboarding"
                      backGroundUrl={ImageOnboarding}
                      imageUrl={ImageSchoolLeader}
                      isImagePadding
                      openCard={openSchoolLeaderOnboarding}
                      adminIcon={true}
                      section="onboarding"
                      mainIcon={<Icon src={IconSchoolLeader} />}
                      hoverTitle="Access a plan for implementing Open Parachute in your school."
                      hoverHint=""
                    />
                    {(user.role === UserRoleEnum.DistrictAdmin || isSuperAdmin) && <MainCard
                      titleLine1="District Leader"
                      titleLine2="Onboarding"
                      backGroundUrl={ImageOnboarding}
                      imageUrl={ImageDistrictLeader}
                      isImagePadding
                      openCard={openDistrictLeaderOnboarding}
                      distAdminIcon={true}
                      section="onboarding"
                      mainIcon={<Icon src={IconHandbook} />}
                      hoverTitle="Access resources and materials for implementing Open Parachute across your district."
                      hoverHint=""
                    />}
                  </div>
                  ) :
                  <div className={styles.transitionCardView}>
                    <TransitionCard
                      titleLine1="Educator"
                      titleLine2="Onboarding"
                      backGroundUrl={ImageWideBackground}
                      imageUrl={ImageEducatorOnboarding1}
                      openCard={openEducatorOnboardingProgram}
                      isComingSoon={false}
                      mainIcon={
                        <Icon src={IconEducatorOnboarding} isComingSoon={false} />
                      }
                      hoverTitle="Prepare teachers to confidently deliver the program in their classrooms. Learn how to navigate the platform and effectively implement the lesson materials with students."
                      hoverHint=""
                    />
                  </div>
                }
                </>
              <TitleCard
                title="Getting Started"
                detail="Prepare to run Lessons; Understand the Platform"
                leftIcon={<Icon src={IconGettingStarted} isTitle={true} />}
              />
              <div className={styles.cardView}>
                <MainCard
                  titleLine1="Quickstart"
                  titleLine2="for Educators"
                  backGroundUrl={ImageGettingstarted}
                  imageUrl={ImageQuickStart}
                  section="Getting"
                  openCard={openQuickStartEducator}
                  isComingSoon={false}
                  mainIcon={
                    <Icon src={IconEducatorOnboarding} isComingSoon={false} />
                  }
                  hoverTitle="Visit our Help Centre to review helpful documentation to get started. These informative guides are designed to get you up and running quickly!"
                  hoverHint="If you would like to dive deeper, there are plenty of in-depth resources available too!"
                />
                <MainCard
                  titleLine1="Curriculum"
                  titleLine2="Overviews"
                  backGroundUrl={ImageGettingstarted}
                  imageUrl={ImageScopeSequence}
                  isImagePadding
                  openCard={openScopeSequece}
                  isPdf={true}
                  section="onboarding"
                  mainIcon={<Icon src={IconPreProgramQuiz} />}
                  hoverTitle="View the Scope & Sequence for each Grade."
                  hoverHint=""
                />
                <MainCard
                  titleLine1="Lesson"
                  titleLine2="Roadmaps"
                  backGroundUrl={ImageGettingstarted}
                  imageUrl={ImageLessonRoadMaps}
                  section="Getting"
                  openCard={intercomGettingStarted}
                  mainIcon={<Icon src={IconGettingStarted} />}
                  hoverTitle="Lesson Roadmaps provide lesson recommendations for every grade to help you get started quickly."
                  hoverHint="Select the best path based on the needs and comfort level of your class!"
                />
                <MainCard
                  titleLine1="Caregiver"
                  titleLine2="Introduction"
                  backGroundUrl={ImageGettingstarted}
                  imageUrl={ImageCareGiverIntroduction}
                  openCard={openCaregiverIntroduction}
                  isPdf={true}
                  isAdmin={true}
                  section="onboarding"
                  mainIcon={<Icon src={IconCaregiverIntroduction} />}
                  hoverTitle="Use this guide to introduce Open Parachute to your Caregiver community."
                  hoverHint="Caregivers can access online resources via their own Portal. The link is found in this PDF!"
                />
                {(isAdminOrDistAdmin || isSuperAdmin) && <MainCard
                  titleLine1="Schedule"
                  titleLine2="Support Call"
                  backGroundUrl={ImageGettingstarted}
                  imageUrl={ImageKickOffCall}
                  isImagePadding
                  openCard={openScheduleKickOffCall}
                  adminIcon={true}
                  isTrial={isTrial}
                  section="onboarding"
                  mainIcon={<Icon src={IconKickOffCall} />}
                  hoverTitle="Book in a Video Conference call with our Team to assist with Implementing Open Parachute at your school."
                  hoverHint="Ensure the key people who oversee Wellbeing at your school can attend this call."
                />}
              </div>
              {(isAdminOrDistAdmin || isSuperAdmin) && (
                <>
                  <TitleCard
                    title="User Management"
                    detail="Invite your staff; Manage their accounts; Reset Passwords; View their Usage."
                    leftIcon={<Icon src={IconAdminTop} isTitle={true} />}
                    isAdmin={isSuperAdmin ? true : false}
                  />
                  <div className={styles.cardView}>
                    <MainCard
                      titleLine1="User"
                      titleLine2="Management"
                      backGroundUrl={ImageAdmin}
                      openCard={openUserManage}
                      isAdmin={true}
                      section="Admin"
                      mainIcon={<Icon src={IconUserManage} />}
                      hoverTitle="Manage all your staff. Reset Passwords, check their usage, delete accounts."
                      hoverHint="See the last time a staff member logged in, who hasn’t accepted their invite, and what Lessons they have run!"
                    />
                    <MainCard
                      titleLine1="Invite"
                      titleLine2="Staff"
                      backGroundUrl={ImageAdmin}
                      openCard={inviteUserHandler}
                      isAdmin={true}
                      section="Admin"
                      mainIcon={<Icon src={IconInviteStaff} />}
                      hoverTitle="Click here to open the Invite Panel, where you can invite staff individually or in bulk."
                      hoverHint="There’s 3 ways to get staff access; Individual Invites; Bulk Invites; and a Registration Link"
                    />
                    <MainCard
                      titleLine1="Usage"
                      titleLine2="Insights"
                      imageUrl={ImageUsageGraph}
                      backGroundUrl={ImageAdmin}
                      openCard={openUsagePage}
                      isComingSoon={user.role === UserRoleEnum.User}
                      isAdmin={true}
                      isUsageGraph={true}
                      section="Admin"
                      mainIcon={
                        <Icon src={IconViewUsage} isComingSoon={user.role === UserRoleEnum.User} />
                      }
                      hoverTitle="View all your staff's usage in one place. Track which staff are most active, which grade levels have the highest use, and how many lessons have been completed!"
                    />
                  </div>
                </>
              )}
              {<WellBeingFoundationsSection isAUuser={isAussie} />}
              {isSuperAdmin || isAdminOrDistAdmin ? (
                <>
                  {classroomLessons()}
                  {reports()}
                </>
              ) : (
                <>
                  {classroomLessons()}
                  {reports()}
                </>
              )}

              <TitleCard
                title="Educator & Caregiver Resources"
                detail="Resources to support Educators and Caregivers"
                leftIcon={<Icon src={IconAdultResource} isTitle={true} />}
              />
              <div className={styles.cardView}>
                <MainCard
                  titleLine1="Professional"
                  titleLine2="Development"
                  backGroundUrl={ImageResources}
                  imageUrl={ImageResilient}
                  section="Resources"
                  openCard={openProfessionalDevelopment}
                  isImagePadding={true}
                  mainIcon={<Icon src={IconProfessional} />}
                  hoverTitle="Professional Development resources for Educators"
                  hoverReleaseDate=""
                />
                <MainCard
                  titleLine1="Caregiver"
                  titleLine2="Resources"
                  backGroundUrl={ImageResources}
                  imageUrl={ImageCareResources}
                  section="Resources"
                  isImageLargePadding={true}
                  openCard={openCaregiver}
                  mainIcon={<Icon src={IconCaregiver} />}
                  hoverTitle="Resources for Caregivers to help support the wellbeing of their children at home."
                  hoverHint="Caregivers can access these resources using their own Portal. Use the Share button to generate a link!"
                />
                <MainCard
                  titleLine1="Supporting Students"
                  titleLine2="In Times of Change"
                  backGroundUrl={ImageResources}
                  imageUrl={ImageSupportStudent}
                  section="Resources"
                  openCard={openSupportingStudentBook}
                  isPdf={true}
                  subTitleClassName={styles.supportingStudent}
                  mainIcon={<ImageOutlineJumping />}
                  hoverTitle="Download a PDF guide for supporting students during transitions."
                  hoverHint=""
                />
              </div>
              <TitleCard
                title="Support"
                detail={`Discover additional information in our ${isUS ? 'Help Center' : 'Help Centre'}, or contact us using the Live Chat`}
                leftIcon={<Icon src={IconSupport} isTitle={true} />}
              />
              <div className={styles.cardView}>
                <MainCard
                  titleLine1="Help"
                  titleLine2={isUS ? 'Center' : 'Centre'}
                  backGroundUrl={ImageSupport}
                  section="Support"
                  openCard={openHelpCentre}
                  mainIcon={<Icon src={IconHelp} />}
                  hoverTitle="Access further help and resources for getting Started."
                  hoverHint={`The ${isUS ? 'Help Center' : 'Help Centre'} also features guides and videos for how to support struggling students.`}
                />
                <MainCard
                  titleLine1="Live"
                  titleLine2="Chat"
                  backGroundUrl={ImageSupport}
                  section="Support"
                  openCard={openLiveChat}
                  mainIcon={<Icon src={IconChat} />}
                  hoverTitle="Chat with a member of the Open Parachute team!"
                  hoverHint="Ask questions about the content, getting started, or any technical issues."
                />
              </div>
              <TitleCard
                title="My Account"
                detail="View active lessons and profile"
                leftIcon={<Icon src={IconMyAccount} isTitle={true} />}
              />
              <div className={styles.cardView}>
                <MainCard
                  titleLine1="View Active"
                  titleLine2="Lessons"
                  backGroundUrl={ImageAccount}
                  imageUrl={ImageViewActiveLessons}
                  section="Support"
                  openCard={openLessonProgress}
                  mainIcon={<Icon src={IconLessonProgress} />}
                  hoverTitle="View all the lessons you have begun and completed."
                  hoverHint="Reset your Lesson Progress Bars at the beginning of each new School Year!"
                />
                <MainCard
                  titleLine1="My"
                  titleLine2="Profile"
                  backGroundUrl={ImageAccount}
                  section="Profile"
                  openCard={openMyProfile}
                  mainIcon={<Icon src={IconMyAccount} />}
                />
              </div>
            </div>}
          </div>
        }
      </div>
      <Footer />
      {showUnitModal && (
        <UnitProgressModal
          open={showUnitModal}
          onClose={handleCloseUnit}
          unitId={unitId}
          assessments={assessments}
          isPostProgram={isPostProgram}
        />
      )}
      {isAdminOrDistAdmin && inviteSlide && (
        <InviteSlidingPanel
          bulkInviteSlide={inviteSlide}
          setBulkInviteSlide={setInviteSlide}
        />
      )}
      {isSuperAdmin && inviteSlide && (
        <SAInviteSlidePanel
          bulkInviteSlide={inviteSlide}
          setBulkInviteSlide={setInviteSlide}
        />
      )}
      {showHandbook && (
        <Handbook
          open={showHandbook}
          onClose={() => setShowHandbook(false)}
          filePath="handbook.pdf"
        />
      )}
      {showPlatformTower && lessonId && (
        <LessonProgressModal
          open={showPlatformTower}
          onClose={() => setShowPlatformTower(false)}
          lessonId={PlatformTowerId}
          isPlatformTower={true}
        />
      )}
      {showAusPreProgram && (
        <LessonProgressModal
          open={showAusPreProgram}
          onClose={() => setShowAusPreProgram(false)}
          lessonId={lessonId}
          isAusPreProgramQuiz={showAusPreProgram}
          gradeName={selectedGrade}
        />
      )}
      {showSelectGradeModal && 
      <GradeSelectModal
        open={showSelectGradeModal}
        onClose={() => setShowSelectGradeModal(false)}
        onContinue={handleOpenAusPreProgramQuiz}
      />
      }
    </>
  );
}

export default Dashboard;
